import { Fragment } from 'react';

import { ToggleLabel } from 'components/FormComponents';

export const ExtraOptions = ({ register, name, options }) => {
  if (!options?.length) return null;

  return options.map(option => (
    <Fragment key={option.code}>
      <div className="u-divider u-margin-y--small" />
      {option.type === 'bool' && (
        <ToggleLabel register={register} name={`${name}.${option.code}`} label={option.title} />
      )}
    </Fragment>
  ));
};
